import { getQuery } from '@/utils/utils'

// 是否要展示裂变的入口：活动入口、弹框等
export function is_display_fission_entry() {
  // if (process.client) {
  //   if (window.abtest_show_fission_entry * 1 === 0) {
  //     return false
  //   }
  // }
  // return true
  // const query = getQuery('fissionSwitch')
  // return query * 1 === 1
  return true
}
// 印尼 mlbb 活动弹框
export function idMlbbActivityPopup() {
  if (process.client) {
    if (window.abtest_IdMlbb_type * 1 === 1) {
      return 1
    }
    if (window.abtest_IdMlbb_type * 1 === 2) {
      return 2
    }
  }
  return 3
}

// 裂变活动“被分享者”弹框展示样式
export const fissionGuestPopupDisplayMode = () => {
  if (process.client) {
    // 展示两个按钮
    const query = getQuery('fgpm')
    if (window.abtest_fission_guest_popup_mode * 1 === 2 || query * 1 === 1) {
      return 2
    }
    return 1
  }
  return 1
}

export const ru_mlbb_banner = () => {
  if (process.client) {
    if (window.abtest_ru_mlbb_banner) {
      return window.abtest_ru_mlbb_banner
    }
    return ''
  }
  return ''
}
export const id_mlbb_banner = () => {
  if (process.client) {
    if (window.abtest_id_mlbb_banner) {
      return window.abtest_id_mlbb_banner
    }
    return ''
  }
  return ''
}

// pubgm 分享者 未登录弹框ab test
export const pubgm_fission_noLoginPopup_sharer = () => {
  if (process.client) {
    const query = getQuery('fn-owner')
    if (window.abtest_pubgm_fission_noLogin_sharer || query) {
      return true
    }
    return false
  }
  return false
}

// pubgm 被分享者 未登录弹框ab test
export const pubgm_fission_noLoginPopup_sharee = () => {
  if (process.client) {
    const query = getQuery('fn-guest')
    if (window.abtest_pubgm_fission_noLogin_sharee || query) {
      return true
    }
    return false
  }
  return false
}
